import axios from 'axios'
import { handleApiError } from '@/utils/apiHelpers'

export default {
    getCuttingJobs({ commit }, {
        paginate = '',
        query = ''
    } = {}) {
        commit('GET_CUTTING_JOBS_REQUEST')

        return axios
            .get(`/cutting-jobs/cutting-jobs${paginate}${query}`)
            .then(response => {
                commit('GET_CUTTING_JOBS_SUCCESS', response.data)

                return Promise.resolve(response)
            })
            .catch(error => {
                commit('GET_CUTTING_JOBS_FAILURE')
                handleApiError(error, 'Pobranie listy zleceń docięcia nie powiodło się.')

                return Promise.reject(error)
            })
    },
    generateReport({ commit }, {
        paginate = '',
        query = '',
        userEmail
    } = {}) {
        commit('GENERATE_REPORT')

        return axios
            .get(`/cutting-jobs/cutting-jobs${paginate}${query}&report=true`)
            .then(response => {
                commit('GENERATE_REPORT_SUCCESS')
                commit('SHOW_NOTIFICATION', {
                    type: 'success',
                    message: `Raport zostanie wygenerowany i przesłany na adres ${userEmail}.`
                }, { root: true })

                return Promise.resolve(response)
            })
            .catch(error => {
                commit('GENERATE_REPORT_FAILURE')
                handleApiError(error, 'Generowanie raportu zleceń docięcia nie powiodło się')

                return Promise.reject(error)
            })
    },
    getChannels({ commit }) {
        return axios
            .get('/cutting-jobs/dicts/channels')
            .then(response => {
                commit('SET_CHANNELS', response.data)

                return Promise.resolve(response.data)
            })
            .catch(error => {
                handleApiError(error, 'Pobranie listy kanałów docięcia nie powiodło się.')

                return Promise.reject(error)
            })
    },
    getStatuses({ commit }) {
        return axios
            .get('/cutting-jobs/dicts/statuses')
            .then(response => {
                commit('SET_STATUSES', response.data)

                return Promise.resolve(response.data)
            })
            .catch(error => {
                handleApiError(error, 'Pobranie listy statusów docięcia nie powiodło się.')

                return Promise.reject(error)
            })
    },
    getCuttingJobReportItems(_, { query = '' }) {
        return axios
            .get(`/cutting-jobs/cutting-jobs-report-items${query}`)
            .then(response => {
                return Promise.resolve(response)
            })
            .catch(error => {
                handleApiError(error, 'Pobranie źródeł docięcia nie powiodło się.')

                return Promise.reject(error)
            })
    },
    cuttingJobCardPrint(_, payload) {
        return axios
            .post('cutting-jobs/cutting-job-card-print', payload, {
                responseType: 'arraybuffer'
            })
            .then(response => {
                return Promise.resolve(response)
            })
            .catch(error => {
                handleApiError(error, 'Wydruk karty zlecenia docięcia nie powiódł się.')

                return Promise.reject(error)
            })
    },
    createCuttingJob(_, payload) {
        return axios
            .post('/cutting-jobs/cutting-jobs', payload)
            .then(response => {

                return Promise.resolve(response)
            })
            .catch(error => {
                handleApiError(error, 'Utworzenie zlecenia docięcia nie powiodło się.')

                return Promise.reject(error)
            })
    },
    updateCuttingJob(_, { id, payload }) {
        return axios
            .put(`/cutting-jobs/cutting-jobs/${id}`, payload)
            .then(response => {

                return Promise.resolve(response)
            })
            .catch(error => {
                handleApiError(error, 'Aktualizacja zlecenia docięcia nie powiodła się.')

                return Promise.reject(error)
            })
    },
    canEditCuttingJob(_, { id }) {
        return axios
            .get(`/cutting-jobs/cutting-jobs/${id}/can-edit`)
            .then(response => {
                return Promise.resolve(response.data)
            })
            .catch(error => {
                handleApiError(error)

                return Promise.reject(error)
            })
    },
    canDeleteCuttingJob(_, { id }) {
        return axios
            .get(`/cutting-jobs/cutting-jobs/${id}/can-delete`)
            .then(response => {
                return Promise.resolve(response)
            })
            .catch(error => {
                handleApiError(error)
                
                return Promise.reject(error)
            })
    },
    deleteCuttingJob(_, { id }) {
        return axios
            .delete(`/cutting-jobs/cutting-jobs/${id}`)
            .then(response => {
                return Promise.resolve(response)
            })
            .catch(error => {
                handleApiError(error, 'Wystąpił problem podczas usuwania zlecenia docięcia.')
                
                return Promise.reject(error)
            })
    },
}
